import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    header: {
        label: "Название",
        inputProps: { name: "header" },
        validators: [requiredField],
        required: true,
    },
    text: {
        // field
        label: "Текст новости",
        inputProps: { name: "text" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
